// extracted by mini-css-extract-plugin
export default {"indent":"gg7fZOuVpU","error":"hkXotbPS66"};